import React from 'react'

export const Slide = ({ children }) => (
  <div className="slide swiper-slide">{children}</div>
)
